import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  Put,
} from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const OffersEndpoint = {
  getAdvertisement: `/admin/advertisement/list`,
  getAdvertisementbyId: `/admin/advertisement/details/`,
  deleteAdvertisement: `/admin/advertisement/delete/`,
  editAdvertisement: `/admin/advertisement/edit/`,
  adAdvertisement: `/admin/advertisement/add`,
  uploadImage: `/admin/advertisement/uploadImage`,
};

export const getAdvertisement = (param = "") => {
  const url = getAPIUrl(OffersEndpoint.getAdvertisement, param);
  return Get(HomePageService, url, true);
};
export const getAdvertisementbyId = (param = "") => {
  const url = getAPIUrl(OffersEndpoint.getAdvertisementbyId, param);
  return Get(HomePageService, url, true);
};
export const addAdvertisement = (data, param = "") => {
  const url = getAPIUrl(OffersEndpoint.adAdvertisement, param);
  return Post(HomePageService, url, data, true);
};

export const editAdvertisement = (data, param = "") => {
  const url = getAPIUrl(OffersEndpoint.editAdvertisement, param);
  return Put(HomePageService, url, data, true);
};

export const uploadImage = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k) => {
    if (data[k]) {
      formData.append(k, data[k]);
    }
  });
  const url = getAPIUrl(OffersEndpoint.uploadImage);
  return Post(HomePageService, url, formData, true, true);
};
export const deleteAdvertisement = (param = "") => {
  const url = getAPIUrl(OffersEndpoint.deleteAdvertisement, param);
  return Delete(HomePageService, url, param);
};
